
<script>
  import { socials } from '@config'

  const share = type => {
    const { href } = window.location
    const windowParam = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'

            switch (type) {
                case 'facebook':
                    window.open(`https://www.facebook.com/sharer/sharer.php?u=${href}`, '', windowParam)
                    break;
                case 'odnoklassniki':
                    window.open(`https://connect.ok.ru/offer?url=${href}`, '', windowParam)
                    break;
                case 'vkontakte':
                    window.open(`https://vk.com/share.php?url=${encodeURI(href)}`, '', windowParam)
                    break;
                case 'twitter':
                    window.open(`https://twitter.com/intent/tweet?original_referer=${href}&text=${href}`, '', windowParam)
                    break;
                case 'telegram':
                    window.open(`https://t.me/share/url?url=${href}`, '', windowParam)
                    break;
        }
  }
</script>
<div class="shareIcons">
  {#each socials as { icon, social }, index}
    <div class="share_icon faded-red-three" on:click={() => share(social)} >
      {@html icon}
    </div>
  {:else}
    <div></div>
  {/each}
</div>

<style>
  .shareIcons {
		display: flex;
		align-items: center;
		.share_icon {
      cursor: pointer;
			margin-left: 1rem;
			width: 1.5rem;
			height: 1.5rem;
			:global(*) {
			  transition: fill 0.3s;
				fill: #0c6954;
				&:hover {
				  fill: #c0303a;
				}
			}
			&:first-child {
				margin-left: 0;
			}
		}
	}
</style>


